var cov_1x1vr6eu6e = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Dropdown/Item.tsx",
      hash = "c4eab7f2a8d99c2201142a7198cece3b06511ee1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Dropdown/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 16
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 50
        }
      },
      "3": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "4": {
        start: {
          line: 29,
          column: 29
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "5": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 39
        }
      },
      "6": {
        start: {
          line: 34,
          column: 64
        },
        end: {
          line: 34,
          column: 74
        }
      },
      "7": {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 35,
          column: 71
        }
      },
      "8": {
        start: {
          line: 36,
          column: 33
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 75
        }
      },
      "10": {
        start: {
          line: 43,
          column: 36
        },
        end: {
          line: 43,
          column: 75
        }
      },
      "11": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "12": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 20
        }
      },
      "13": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 105
        }
      },
      "14": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "15": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 71
        }
      },
      "16": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 32
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 16
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 11
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 38
          },
          end: {
            line: 35,
            column: 59
          }
        }, {
          start: {
            line: 35,
            column: 62
          },
          end: {
            line: 35,
            column: 71
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 24
          }
        }, {
          start: {
            line: 35,
            column: 28
          },
          end: {
            line: 35,
            column: 35
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 41,
            column: 14
          },
          end: {
            line: 41,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 23
          },
          end: {
            line: 41,
            column: 65
          }
        }, {
          start: {
            line: 41,
            column: 68
          },
          end: {
            line: 41,
            column: 72
          }
        }],
        line: 41
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 75
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 75
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 75
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 46
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 105
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 49
          },
          end: {
            line: 50,
            column: 86
          }
        }, {
          start: {
            line: 50,
            column: 89
          },
          end: {
            line: 50,
            column: 105
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Dropdown/Item.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { isValidElement, cloneElement } from 'react';
import { defaultProps } from '../utils/defaultProps';
var DefaultProps = (cov_1x1vr6eu6e.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  data: {},
  renderItem: 'content'
}));

var Item =
/*#__PURE__*/
function (_ref) {
  _inherits(Item, _ref);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    cov_1x1vr6eu6e.f[0]++;
    cov_1x1vr6eu6e.s[1]++;
    _this = _super.call(this, props);
    cov_1x1vr6eu6e.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "handleClick",
    value: function handleClick() {
      cov_1x1vr6eu6e.f[1]++;
      cov_1x1vr6eu6e.s[3]++;

      if (!this.props.onClick) {
        cov_1x1vr6eu6e.b[0][0]++;
        cov_1x1vr6eu6e.s[4]++;
        return;
      } else {
        cov_1x1vr6eu6e.b[0][1]++;
      }

      cov_1x1vr6eu6e.s[5]++;
      this.props.onClick(this.props.data);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1x1vr6eu6e.f[2]++;

      var _ref2 = (cov_1x1vr6eu6e.s[6]++, this.props),
          data = _ref2.data,
          itemClassName = _ref2.itemClassName,
          renderItem = _ref2.renderItem,
          width = _ref2.width,
          columns = _ref2.columns;

      var aWidth = (cov_1x1vr6eu6e.s[7]++, (cov_1x1vr6eu6e.b[2][0]++, width) && (cov_1x1vr6eu6e.b[2][1]++, columns) ? (cov_1x1vr6eu6e.b[1][0]++, (width - 2) / columns) : (cov_1x1vr6eu6e.b[1][1]++, undefined));
      var props = (cov_1x1vr6eu6e.s[8]++, {
        disabled: data.disabled,
        onClick: this.handleClick,
        className: itemClassName,
        target: data.target,
        style: aWidth ? (cov_1x1vr6eu6e.b[3][0]++, {
          display: 'inline-block',
          width: aWidth
        }) : (cov_1x1vr6eu6e.b[3][1]++, null)
      });
      cov_1x1vr6eu6e.s[9]++;

      if (data.url) {
        cov_1x1vr6eu6e.b[4][0]++;
        cov_1x1vr6eu6e.s[10]++;
        props.href = data.url;
      } else {
        cov_1x1vr6eu6e.b[4][1]++;
      }

      var content;
      cov_1x1vr6eu6e.s[11]++;

      if (
      /*#__PURE__*/
      isValidElement(data)) {
        cov_1x1vr6eu6e.b[5][0]++;
        cov_1x1vr6eu6e.s[12]++;
        content = data;
      } else {
        cov_1x1vr6eu6e.b[5][1]++;
        cov_1x1vr6eu6e.s[13]++;
        // @ts-ignore
        content = typeof renderItem === 'string' ? (cov_1x1vr6eu6e.b[6][0]++, data[renderItem]) : (cov_1x1vr6eu6e.b[6][1]++, renderItem(data));
      }

      cov_1x1vr6eu6e.s[14]++;

      if (
      /*#__PURE__*/
      isValidElement(content)) {
        cov_1x1vr6eu6e.b[7][0]++;
        cov_1x1vr6eu6e.s[15]++;
        return (
          /*#__PURE__*/
          cloneElement(content, Object.assign(props, content.props))
        );
      } else {
        cov_1x1vr6eu6e.b[7][1]++;
      }

      cov_1x1vr6eu6e.s[16]++;
      return (
        /*#__PURE__*/
        React.createElement("a", Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 12
          }
        }), content)
      );
    }
  }]);

  return Item;
}((React.PureComponent));

Item.defaultProps = DefaultProps;
export default Item;